<template>
  <transition name="fade">
      <div v-if="app_status != 'open'" class="chat-app-discount">
          <svg viewBox="0 0 268.465 268.465" style="enable-background:new 0 0 268.465 268.465;">
            <g>
                <path d="M254.688,50.339c-18.355-18.367-48.238-18.372-66.613-0.015c-0.036,0.036-0.067,0.076-0.102,0.113l-32.631,32.635   c-2.929,2.929-2.928,7.678,0.001,10.606c1.464,1.464,3.383,2.196,5.303,2.196c1.919,0,3.839-0.732,5.304-2.197l32.746-32.75   c0.022-0.022,0.04-0.047,0.063-0.069c12.533-12.434,32.838-12.407,45.323,0.086c12.519,12.516,12.522,32.883,0.008,45.402   l-45.91,45.909c-6.063,6.064-14.126,9.404-22.702,9.404s-16.639-3.339-22.704-9.404c-2.929-2.929-7.678-2.929-10.607,0   c-2.929,2.929-2.929,7.678,0,10.606c8.898,8.897,20.727,13.797,33.31,13.797c12.583,0,24.412-4.9,33.309-13.797l45.91-45.91   C273.059,98.584,273.054,68.7,254.688,50.339z"/>
                <path d="M59.676,105.597l-45.91,45.909c-18.354,18.367-18.354,48.251,0.002,66.619c9.184,9.185,21.247,13.777,33.312,13.776   c12.056-0.001,24.116-4.588,33.297-13.762c0.002-0.003,0.005-0.005,0.008-0.008l32.746-32.755c2.928-2.93,2.928-7.678-0.002-10.607   c-2.93-2.928-7.677-2.928-10.607,0.001l-32.746,32.755c-0.001,0.001-0.001,0.002-0.002,0.003   c-12.52,12.511-32.884,12.506-45.398-0.009c-12.512-12.52-12.512-32.891-0.002-45.409l45.909-45.908   c12.519-12.52,32.888-12.521,45.407-0.004c2.929,2.929,7.678,2.929,10.606-0.001c2.929-2.929,2.928-7.678-0.001-10.606   C107.927,87.227,78.041,87.229,59.676,105.597z"/>
                <path d="M124.413,53.125c1.196,2.889,3.989,4.633,6.933,4.633c0.956,0,1.928-0.184,2.866-0.572   c3.827-1.584,5.646-5.971,4.061-9.798l-8.469-20.459c-1.583-3.827-5.971-5.645-9.798-4.061c-3.827,1.584-5.646,5.971-4.061,9.798   L124.413,53.125z"/>
                <path d="M153.883,57.185c0.939,0.389,1.911,0.573,2.868,0.573c2.942,0,5.735-1.743,6.932-4.631l8.477-20.455   c1.585-3.827-0.231-8.214-4.058-9.8c-3.826-1.585-8.213,0.23-9.8,4.058l-8.477,20.455C148.24,51.211,150.057,55.599,153.883,57.185   z"/>
                <path d="M90.046,66.681l20.451,8.478c0.939,0.39,1.912,0.574,2.869,0.574c2.942,0,5.734-1.743,6.931-4.63   c1.586-3.826-0.229-8.214-4.056-9.8l-20.451-8.479c-3.826-1.588-8.214,0.23-9.8,4.056C84.404,60.707,86.22,65.095,90.046,66.681z"/>
                <path d="M144.054,215.342c-1.585-3.827-5.971-5.646-9.798-4.062c-3.827,1.584-5.646,5.971-4.062,9.798l8.467,20.458   c1.196,2.889,3.989,4.634,6.933,4.634c0.956,0,1.927-0.184,2.865-0.572c3.827-1.584,5.646-5.971,4.062-9.798L144.054,215.342z"/>
                <path d="M114.577,211.28c-3.828-1.586-8.214,0.228-9.801,4.055l-8.48,20.451c-1.587,3.827,0.228,8.214,4.055,9.801   c0.94,0.39,1.913,0.574,2.87,0.574c2.942,0,5.734-1.742,6.931-4.629l8.48-20.451C120.218,217.254,118.403,212.867,114.577,211.28z"/>
                <path d="M178.412,201.782l-20.457-8.479c-3.827-1.587-8.214,0.23-9.8,4.056c-1.586,3.827,0.23,8.214,4.056,9.8l20.457,8.48   c0.939,0.39,1.912,0.574,2.869,0.574c2.942,0,5.734-1.743,6.931-4.63C184.054,207.755,182.238,203.368,178.412,201.782z"/>
            </g>
           </svg>
        <p>Disconnect from server...</p>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
let pumpTimer = null

export default {
  computed: {
      ...mapState(['app_status'])
  },
  updated() {
      let that = this
      if ( this.app_status != 'open') {
          pumpTimer = setInterval(() => {
              console.log('pump')
              this.$remote.$emit('pings', {})
          }, 2000)
      } else {
          clearInterval(pumpTimer)
      }
  }
}
</script>


<style lang="scss" scoped>
.chat-app-discount { top: 0; left: 0; bottom: 0; right: 0; width: 100%; height: 100%; position: absolute; background: rgba(255, 255, 255, .85); color:#111; font-size: 18px; z-index: 2147484000;
    display: flex; align-items: center; justify-content: center; flex-direction: column;
    svg {width: 40px; height: 50px; fill: #FFC107; animation: .65s svgDiscount alternate infinite ease-in-out; }
    p { font-size: 14px; color: #FFC107;}
}
@keyframes svgDiscount {
    0% { transform: scale(.85); opacity: 0;}
    100% { transform: scale(1.25); opacity: 1;}
}
.fade-enter-active, .fade-leave-active {
  transition: all .35s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0; transform: scale(1.25);
}
</style>


// WEBPACK FOOTER //
// src/components/ChatError.vue